import packageJson from '../../package.json';

export default {
  okta: {
    baseUrl: 'https://tempus.okta.com',
    issuer: 'aussrkz0vd8RqqPWo296',
    clientId: '0oar5pjs3oB0Suhsg297',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedClientIds: {
    clinicalPortal: '0oa1ezb8h9tXssNKS297',
    clinicalPortalDemo: '0oa1r6lw5q9ibRhwY297',
    lens: '0oaunisj3cUBNG5PA296',
    lensNotebook: '0oa2o3gf06ElSNg8f297',
    lensGlassDemo: '0oaio5otptoYXac380h7',
    accountUi: '0oar5pjs3oB0Suhsg297',
    nextIntelligence: '0oa7rranl46uqDPET297',
    nextPlatform: '0oa7qpab53dsPv6xV297',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedIssuerIds: {
    default: 'aussrkz0vd8RqqPWo296',
    demo: 'aus1m02r1xcDePqtW297',
  },
  apps: {
    clinicalPortal: 'https://hub.securetempus.com',
    lens: 'https://lens.securetempus.com',
    pixelRad: 'https://pixel-rad.securetempus.com',
    nextIntelligence: 'https://next-intelligence.securetempus.com',
    nextPlatform: 'https://next-platform.securetempus.com',
    providerAccount: 'https://provider-account.securetempus.com',
    ehrIntegrationService: 'https://ehr-integration-service.securetempus.com',
    david: 'https://david.securetempus.com',
  },
  sentry: {
    dsn: 'https://9f8e11e5fbfa4b40b3d703fc2b8e847f@o816116.ingest.sentry.io/4504730124288000',
    environment: 'prd',
    enabled: true,
    release: `${packageJson.name}@${packageJson.version}`,
  },
  // Okta OIDC IdP "Tempus Auth0 Providers - Prd" → login.securetempus.com.
  // Live on merge: blank this value to disable the daisy chain in prd.
  auth0: {
    oktaIdpId: '0oa135idsvqZGAGmR298',
    sessionInitDomain: 'login.securetempus.com',
    sessionInitClientId: 'SFp2Ul1rn6BfoHE4NuRZ0zHma8ZmGaNi',
    sessionInitConnection: 'TempusAI-WIC',
  },
  whitelistedRedirectDomain: ['.prd.gcp.tempus.cloud', '.val.gcp.tempus.cloud', '.securetempus.com'],
};
